import { create } from 'zustand';
import type { CurrentUser } from '@/lib/types';

/**
 * Client-side mirror of `/api/auth/me`. We could rely entirely on
 * react-query but a tiny zustand store keeps the `me` value reachable
 * from non-React surfaces (e.g. WebSocket clients that need to attach
 * the current username on connect).
 */
interface AuthState {
  user: CurrentUser | null;
  /** True until the first /auth/me settles, so guards can render a splash instead of bouncing. */
  initialised: boolean;
  setUser: (u: CurrentUser | null) => void;
  setInitialised: (v: boolean) => void;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  initialised: false,
  setUser: (u) => set({ user: u }),
  setInitialised: (v) => set({ initialised: v }),
}));
